import PriceEditorContainer from './containers/PriceEditorContainer'

export default PriceEditorContainer
